"use strict";
global.is_empty = function is_empty(elem) {
    var a;
    elem.find('.req').each(function () {
        if ($(this).val().length == 0 || !$(this).val().replace(/\s+/g, '')) {
            $(this).addClass('invalid');
            a = 0;
        } else if ($(this).hasClass("phone") && $(this).val().length != 17) {
            $(this).addClass('invalid');
            a = 0;
        } else if ($(this).hasClass("mail") && !validateEmail($(this).val())) {
            $(this).addClass('invalid');
            a = 0;
        } else $(this).removeClass('invalid');
    });
    if (a != 0) a = 1;

    return a;
}

global.validateEmail = function validateEmail($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test($email);
}

global.pluralForm = function pluralForm(n, forms) {
    return n % 10 == 1 && n % 100 != 11 ? forms[0] : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? forms[1] : forms[2]);
}


$(document).ready(function () {
    let leftZIndex = 1005;

    $('.md-trigger').click(function () {
        $('.md-modal').removeClass('md-show');
        const modal = $('#' + $(this).data('modal'));
        leftZIndex = leftZIndex+1;

        console.log(leftZIndex, 'testing');

        modal
            .css('visibility', 'visible')
            .css('z-index', leftZIndex);

        $('#' + $(this).data('modal'))
            .addClass('md-show');
    });

    $('.md-overlay').click(function () {
        const $target = $(event.target);

        if (!$target.closest('.md-content').length) {
            $('.md-modal')
                .removeClass('md-show')
                .css('visibility', 'hidden');
        }
    });

    $(document).on("click", function (e) {
        if (!$(e.target).closest(".h_profile").length) $(".profile_menu_toggle").removeClass("active");
    });

    $(document).on("click", ".profile_menu_toggle", function () {
        $(this).toggleClass("active");
    });

    $(document).on('click', '.navTrigger', function () {
        var width_scroll = 0;
        if ($(".navTrigger").hasClass("active")) {
            $(".navTrigger").add($("nav")).removeClass("active");
            $('body, html').removeAttr('style');
        } else {
            if (is_scroll()) {
                width_scroll = calculate_scroll_width();
            }
            $("html").css({'padding-right': width_scroll + 'px'});
            $("body").css("cssText", "overflow: hidden;");
            $(".navTrigger").add($("nav")).addClass("active");


        }
    });
    $(document).on('click', '.btn_go_to', function (e) {
        e.preventDefault();
        var $this, data_href, obj;
        $this = $(this);
        data_href = $this.attr('href') ? $this.attr('href') : $this.attr('data-href');
        obj = $(data_href).eq(0);
        if (obj.length) {
            $('html, body').dequeue().stop().animate({scrollTop: obj.offset().top - 60}, 1000);
        }
    });

    function is_scroll() {
        return $(document).height() > $(window).height();
    }

    function calculate_scroll_width() {
        var hide_block, css_text, width_scroll;
        hide_block = document.createElement('div');
        css_text = "width:100%!important; height:100px; position:fixed; left:100%; top:100%; overflow:scroll;";
        hide_block.id = "hide_block";
        hide_block.setAttribute('style', css_text);
        document.body.appendChild(hide_block);
        width_scroll = parseFloat(hide_block.offsetWidth - hide_block.clientWidth, 10);
        hide_block.parentElement.removeChild(hide_block);
        return width_scroll;
    }

    function center_modal(selector) {
        var obj, width_scroll;
        obj = $(selector);
        if (obj.length == 0) return 0;
        width_scroll = is_scroll() ? calculate_scroll_width() : 0;
        $('html').css('padding-right', width_scroll + 'px');
        $("body").css("cssText", "overflow: hidden;");
        obj.fadeIn(200);
    }

    function get_auth_modal(e) {
        var obj;
        e.preventDefault();
        obj = $("#login_auth");
        if (!obj.length) return;
        center_modal("#login_auth");
    }


    function to_close_modal() {
        $('.popup_layout, .popup_wrapper, .auth_popup_wrapper').fadeOut(200);
        $('body, html').removeAttr('style');
    }


    function close_modal(e) {
        e.preventDefault();
        e.stopPropagation();
        to_close_modal();
    }

    function close_popup(e) {
        if ($(e.target).closest('.popup_inner').length !== 0) return;
        to_close_modal();
    }

    /*
    $(document).on('click', '.login_btn', function (e) {
        $('.text-error').text('text-error');
        $('.text-error').hide();
        get_auth_modal(e);

        if (RECAPTCHA.renderedRecaptchaV2) {
            $('.recaptcha_block').show();
        }
    });*/

    $(document).on('click', '.forgot_btn', function (e) {
        e.preventDefault();
        $("#login_auth").fadeOut(0);
        $("#forgot").fadeIn(0);
        $('.text-error').text('text-error');
        $('.text-error').hide();
        center_modal("#forgot");
    });

    $(document).on('click', '.register_btn', function (e) {
        e.preventDefault();
        $("#login_auth").fadeOut(0);
        $("#register_auth").fadeIn(0);
        $('.text-error').text('text-error');
        $('.text-error').hide();
        center_modal("#register_auth");
    });

    $(document).on('click', '.login_btn_back', function (e) {
        e.preventDefault();
        $("#register_auth").fadeOut(0);
        $("#forgot").fadeOut(0);
        $("#login_auth").fadeIn(0);
        $('.text-error').text('text-error');
        $('.text-error').hide();
        center_modal("#login_auth");
    });

    let inputRegisterPassword = $('input.register_password');

    $('.show_password').mousedown(function () {
        $(this).css('background', 'url(/images/eye.svg) no-repeat');
        inputRegisterPassword.attr('type', 'text');
    }).mouseup(function () {
        $(this).css('background', 'url(/images/eye_1.svg) no-repeat');
        inputRegisterPassword.attr('type', 'password');
    }).mouseout(function () {
        $(this).css('background', 'url(/images/eye_1.svg) no-repeat');
        inputRegisterPassword.attr('type', 'password');
    });

    $("[name=phone]").mask("+7 (999) 999-9999");

    const formRegister = $('#form-register');
    let isSubmitedRegisterForm = false;
    formRegister.submit(function (e) {
        e.preventDefault();

        if (isSubmitedRegisterForm) {
            return;
        }

        isSubmitedRegisterForm = true;

        const fields = [
            'email',
            'email_confirmation',
            'phone',
            'password',
            'g-recaptcha-response',
            'agreement'
        ];

        for (let i in fields) {
            formRegister.find('.text-error.' + fields[i]).hide();
        }

        let request = formRegister.serialize();
        const requestFunction = function () {
            axios.post(jsRouteRegisterAjax, request).then((r) => {
                formRegister.find('i.valid_send').show();

                window.location.reload();
            }).catch(e => {
                if (e.response.status == 422) {
                    for (let i in fields) {
                        formRegister.find('.text-error.' + fields[i]).hide();
                        try {
                            formRegister.find('.text-error.' + fields[i]).text(
                                e.response.data.errors[fields[i]][0]
                            );
                            formRegister.find('.text-error.' + fields[i]).show();
                        } catch (e) {
                        }
                    }
                } else {
                    Swal.fire('Ошибка при выполнении запроса. Мы уже знаем и решаем проблему.', '', 'error');
                }
            }).finally(() => {
                formRegister.find('i.loader_form').hide();
                isSubmitedRegisterForm = false;
            });
        }

        try {
            RECAPTCHA.initRecaptcha((r) => {
                formRegister.find('i.loader_form').show();

                grecaptcha.ready(function () {
                    grecaptcha.execute(RECAPTCHA.recaptchaKeyV3, {action: 'submit'}).then(function (token) {
                        request += '&g-recaptcha-response=' + token;

                        requestFunction();
                    });
                });
            });
        }
        catch (e) {
            requestFunction();
        }
    });

    const formAuth = $('#form-auth');
    let isSubmitedAuthForm = false;

    formAuth.submit(function (e) {
        e.preventDefault();

        if (isSubmitedAuthForm) {
            return;
        }

        isSubmitedAuthForm = true;
        const fields = [
            'email',
            'password'
        ];

        for (let i in fields) {
            formAuth.find('.text-error.' + fields[i]).hide();
        }

        formAuth.find('i.loader_form').show();

        axios.post(jsRouteLoginAjax, formAuth.serialize()).then((r) => {
            formAuth.find('i.valid_send').show();

            window.location.reload();
        }).catch(e => {
            if (e.response.status == 422) {
                for (let i in fields) {
                    formAuth.find('.text-error.' + fields[i]).hide();
                    try {
                        formAuth.find('.text-error.' + fields[i]).text(
                            e.response.data.errors[fields[i]][0]
                        );

                        formAuth.find('.text-error.' + fields[i]).show();
                    } catch (e) {
                    }
                }
            } else {
                Swal.fire('Ошибка при выполнении запроса. Мы уже знаем и решаем проблему.', '', 'error');
            }
        }).finally(() => {
            isSubmitedAuthForm = false;
            formAuth.find('i.loader_form').hide();
        });
    });

    const formForgot = $('#form-forgot');
    let isSubmitedForgotForm = false;
    formForgot.submit(function (e) {
        e.preventDefault();

        if (isSubmitedForgotForm) {
            return;
        }

        isSubmitedForgotForm = true;

        const fields = [
            'email'
        ];

        for (let i in fields) {
            formForgot.find('.text-error.' + fields[i]).hide();
        }

        formForgot.find('i.loader_form').show();

        axios.post(jsRouteForgotAjax, formForgot.serialize()).then((r) => {
            formForgot.find('i.valid_send').show();

            window.location.reload();
        }).catch(e => {
            if (e.response.status == 422) {
                for (let i in fields) {
                    formForgot.find('.text-error.' + fields[i]).hide();
                    try {
                        formForgot.find('.text-error.' + fields[i]).text(
                            e.response.data.errors[fields[i]][0]
                        );
                        formForgot.find('.text-error.' + fields[i]).show();
                    } catch (e) {
                    }
                }
            } else {
                Swal.fire('Ошибка при выполнении запроса. Мы уже знаем и решаем проблему.', '', 'error');
            }
        }).finally(() => {
            isSubmitedForgotForm = false;
            formForgot.find('i.loader_form').hide();
        });
    });

    $(".close_btn").click(function (e) {
        close_modal(e);
    });

    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 0) {
            $("header").addClass("scroll");
        } else {
            $("header").removeClass("scroll");
        }
    });
    $(window).on("load", function () {
        if ($(window).scrollTop() > 0) {
            $("header").addClass("scroll");
        } else {
            $("header").removeClass("scroll");
        }
    });

    if ($(".reviews_slider").length > 0) {
        $(".reviews_slider").slick({
            adaptiveHeight: true,
            arrows: false,
            dots: true
        });
    }

    $('.form input[type="text"]').focus(function () {
        if ($(this).hasClass('invalid')) {
            $(this).removeClass('invalid');
        }
    });


    if (window.location.href.includes('register=1')) {
        $('.register_btn').click();
    }
});


if (document.getElementById("home-feedback") !== null) {
    new Vue({
        el: '#home-feedback',
        data: () => {
            return {
                loading: false,
                successSend: false,
                form: {
                    id: 'home-feedback',
                    name: null,
                    email: null,
                    idea: null,
                    agreement: false,
                    'g-recaptcha-response': null
                },
                errors: {}
            }
        },
        methods: {
            submitForm() {
                if (this.loading) {
                    return;
                }

                this.loading = true;

                try {
                    RECAPTCHA.initRecaptcha((r) => {
                        grecaptcha.ready((r) => {
                            grecaptcha.execute(RECAPTCHA.recaptchaKeyV3, {action: 'submit'}).then((token) => {
                                this.form['g-recaptcha-response'] = token;

                                this.sendRequest();
                            });
                        });
                    });
                }
                catch (e) {
                    this.sendRequest();
                }
            },
            sendRequest() {
                axios.post('/api/pages/ideas/send', this.form).then((r) => {
                    this.successSend = true;
                    this.form.name = null;
                    this.form.email = null;
                    this.form.idea = null;
                    this.form['g-recaptcha-response'] = null;
                    this.form.agreement = false;
                    this.errors = {};
                    Swal.fire('Успешно отправлено');
                }).catch((e) => {
                    if (e.response.status === 422) {
                        this.errors = e.response.data.errors;
                    } else {
                        Swal.fire('Ошибка при выполнении запроса. Мы уже знаем и решаем проблему.', '', 'error');
                    }
                }).finally((r) => {
                    this.loading = false;
                    setTimeout(() => {
                        this.successSend = false;
                    }, 1000);
                });
            }
        }
    });
}
